import React, { useRef } from "react"
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { useParams } from "react-router";
import { useScheduledCasesFindQuery } from "../../../../services/scheduleService/schedule-api";
import { Button } from "@mui/material";
import FileDownloadOffIcon from '@mui/icons-material/FileDownloadOff';

function ScheduleExport(){
    const {id} = useParams();
    const cases = useScheduledCasesFindQuery(id!);
    const excelExportRef = useRef<ExcelExport>(null);

    const formatDate = (date: Date): string => {
      return new Intl.DateTimeFormat("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
      }).format(date);
  };

    const getExportData = () => {
      if(cases.data != null && cases.data != undefined){
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return cases.data!
          .filter(p => new Date(p.start) >= today)
          .map(i => ({
            ...i, 
            start: new Date(i.start), 
            end: new Date(i.end), 
            startString: formatDate(new Date(i.start)), 
            endString: formatDate(new Date(i.end))
          }))
          .sort((a, b) => a.start.getTime() - b.start.getTime());
      }
      return [];
    }

    const handleExport = () => {
      excelExportRef.current?.save(getExportData());
    };

    return <React.Fragment>
        <ExcelExport ref={excelExportRef} fileName={`ScheduledCases_${id}.xlsx`}>
          <ExcelExportColumn field="account" title="Account" width={120} />
          <ExcelExportColumn field="lastName" title="Last Name" width={120} />
          <ExcelExportColumn field="firstName" title="First Name" width={120} />
          <ExcelExportColumn field="startString" title="Start Time" width={160} />
          <ExcelExportColumn field="endString" title="End Time" width={160} />
          <ExcelExportColumn field="room" title="Room" width={100} />
          <ExcelExportColumn field="procedure" title="Procedure" width={120} />
          <ExcelExportColumn field="physician" title="Physician" width={150} />
          <ExcelExportColumn field="apptNotes" title="Appointment Notes" width={300} />
        </ExcelExport>
        <Button variant='outlined' color='success' startIcon={<FileDownloadOffIcon/>} onClick={handleExport}>Export</Button>
    </React.Fragment>
}
export {ScheduleExport}